<template>
    <div id="PowerDistribution">
        <div class="subcontainer-one column-center" v-if="$store.getters.projectId!=20">
           <WiringLine ></WiringLine>
        </div>
        <div class="subcontainer-thr"  v-if="$store.getters.projectId!=20">
            <Diagram :allTransformers="allTransformers"  ref="diagram" v-if="$store.getters.areaId!=78&&$store.getters.areaId!=79"></Diagram>
            <EYMDiagram  v-else></EYMDiagram>
        </div>
        <div class="column-center" style="text-align: center;
    width: 100%;
    height: 100%;
    background: #ffffff" v-if="$store.getters.projectId==20" >
            <img src="../../assets/img/not_found_data.png" alt="">
        </div>
    </div>
</template>

<script>

import Park from "../../components/common/Park";
import Diagram from "./components/Diagram";
import EYMDiagram from "./components/EYMDiagram";
import Monitor from "../../components/common/Monitor";
import WiringLine from "./components/WiringLine.vue";

import { GET_AREAS, transformerList, getAreaWiring } from '../../api/power'
export default {
    data(){
        return {
            isFull:false,
            iskuan: false,
            active:0,
            active1:0,
            allTransformers:[],
        }
    },
    components:{
        Park,Monitor,Diagram,WiringLine,EYMDiagram
    },
    created(){
        this.$store.getters.getTypeSite('distribution').forEach((item,index)=>{
            if(item.areaId == this.$store.getters.areaId){
                this.$store.commit('setAreaId', this.$store.getters.getTypeSite('distribution')[index].areaId)
            }else {
                this.$store.commit('setAreaId', this.$store.getters.getTypeSite('distribution')[0].areaId)
            }
        })
    },
    methods:{
        tagsite1(index){
            this.active1 = index
        },
        tagsite(index){
            this.active = index
        },
        kuan(){
            this.iskuan = !this.iskuan
        },
        full() {
            this.isFull = !this.isFull
        },
    },
    mounted(){
        // console.log(this);
    }
}
</script>

<style lang="less" scoped>
    #PowerDistribution{
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        justify-content: space-between;
        align-content: space-between;
        position: relative;
        .subcontainer-one{
            // padding: 1.5vh 5.2vw;
            .h(648);
            .w(1194);
            background: #fff;
            // display: flex;
            // flex-wrap: wrap;
            // align-items: center;
           
        }
        .subcontainer-thr{
            .h(320);
            .w(1194);
            // background: #FFFFFF;
        }
        
    }
</style>